import RequestsPages from './subPages/requests';
import ExtraStocksPages from './subPages/extrastocks';
import ExtrastockOffersPages from './subPages/extrastockOffers';
import ExtraStockContractorsPages from './subPages/extrastockContractors';
import OperationsPages from './subPages/operations';
import EmergencyContactsPages from './subPages/emergencyContacts';
import WaitingListsPages from './subPages/waitingLists';
import CalendarPage from './subPages/calendar';

const routes = [
  {
    path: '/requests/*',
    canUse: [],
    Component: RequestsPages,
  },
  {
    path: '/extrastocks/*',
    canUse: [],
    Component: ExtraStocksPages,
  },
  {
    path: '/extrastock_offers/*',
    canUse: [],
    Component: ExtrastockOffersPages,
  },
  {
    path: '/operations/*',
    canUse: [],
    Component: OperationsPages,
  },
  {
    path: '/emergency_contacts/*',
    canUse: [],
    Component: EmergencyContactsPages,
  },
  {
    path: '/waiting_lists/*',
    canUse: [],
    Component: WaitingListsPages,
  },
  {
    path: '/calendar/*',
    canUse: [],
    Component: CalendarPage,
  },
];

export default routes;
